module.exports = __webpack_public_path__ + "img/weinfo.62393a1e.png";